// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ExistingLicence-module__section___1pvek{margin-top:20px}.ExistingLicence-module__inputBox___12aZ-{border-radius:4px;border:solid 1px #494d56;padding:10px;margin-top:6px;width:100%}.ExistingLicence-module__errorMessage___113t4{margin-top:-15px}", ""]);
// Exports
exports.locals = {
	"section": "ExistingLicence-module__section___1pvek",
	"inputBox": "ExistingLicence-module__inputBox___12aZ-",
	"errorMessage": "ExistingLicence-module__errorMessage___113t4"
};
module.exports = exports;
